import Model from "./Model";
import User from "./User";

export default class Meeting extends Model {

    static timezoneAbbreviations = {
        'Hawaii': 'HST',
        'Alaska': 'AKST',
        'Pacific': 'PST',
        'Mountain': 'MST',
        'Central': 'CST',
        'Eastern': 'EST',
        'Atlantic': 'AST',
        'GMT/UTC': 'GMT',
        'European Central': 'CET',
        'Eastern European': 'EET',
        'Eastern African': 'EAT',
        'Middle East': 'IRST',
        'Near East': 'ADT',
        'Pakistan Lahore': 'PKT',
        'India': 'IST',
        'Bangladesh': 'BST',
        'Vietnam': 'ICT',
        'China Taiwan': 'China ST',
        'Japan': 'JST',
        'Australia Central': 'ACST',
        'Australia Eastern': 'AEST',
        'Solomon': 'SBT',
        'New Zealand': 'NZST',
        'Samoa': 'SST',
        'Canada Newfoundland': 'NST',
        'Brazil Eastern': 'BRT',
        'Central African': 'CAT',
    }

    static cancelled_reasons(forType = null) {

        let cancelled_reasons = TB.flatten(TB.map(laravel.meeting_cancelled_reasons, (reasons, type) => {
            return TB.reduce(reasons, (result, reason, value) => {
                result.push({...reason, value: parseInt(value), type});
                return result;
            }, [])
        }))

        if (!forType) return cancelled_reasons;

        return TB.filter(cancelled_reasons, ['type', forType])
    }

    static talent_cancelled_reasons() {
        return this.cancelled_reasons('talent')
    }

    static client_cancelled_reasons() {
        return this.cancelled_reasons('client')
    }

    static client_cancelled_reason() {
        return TB.find(this.client_cancelled_reasons(), {activity: 'Client Cancelled Meeting'})
    }

    static talent_cancelled_reason() {
        return TB.find(this.talent_cancelled_reasons(), {activity: 'Talent Rejected Meeting'})
    }

    static talent_reschedule_reason() {
        return TB.find(this.talent_cancelled_reasons(), {activity: 'Talent Request Reschedule'})
    }

    static normalize(props) {
        if (props.creator) {
            props.creator = User.make(props.creator)
        }

        props.members = props.members || [];
        if (props.members?.length) {
            let members = TB.map([...props.members], member => {
                if (member.label && member.value) return member;

                let user = User.make({
                    ...member
                })
                user.label = user.firstNamePlusInitial();
                user.value = user.id;
                return user;
            })
            props.members = TB.uniqBy(members, 'value');
        }

        props.available_slots = TB.orderBy([...(props.available_slots)], 'started_at');

        if (props.rejection_reason) {
            props.rejection = TB.find(this.cancelled_reasons(), ['activity', props.rejection_reason])
        }

        if (!props.duration) {
            props.duration = 30;

            let comparison = (props.started_at && props.ended_at)
                ? props : TB.first(props.available_slots);

            if (comparison) {
                let {
                    started_at,
                    ended_at
                } = comparison;

                props.duration = TB.moment(ended_at).diff(started_at,'minutes');
            }
        }

        if (props.status === 'Past' && !props.rejected_at) {
            props.status = 'Completed';
        }
        return props;
    }

    static async fetchMeetingsForProjectTeam(projectId, teamId, requestOptions = {}) {

        this.FetchAllForProjectTeamRequest = TB.request(`/api/meetings/projects/${projectId}/team-candidates/${teamId}`);
        let response = await this.FetchAllForProjectTeamRequest.get(requestOptions).catch(e => {
            console.warn('ERROR:getmeetings ', e)
            throw new Error('Something went wrong')
        });

        if (!TB.has(response, 'success.data.meetings')) {
            throw new Error('Something went wrong')
        }

        return TB.orderBy(this.makeMany([...response.success.data.meetings]), 'created_at');
    }

    static async fetchMeetingsForTalentPosition(positionId, userId, requestOptions = {}) {

        this.FetchAllForTalentPositionRequest = TB.request(`/api/meetings/positions/${positionId}/candidates/${userId}`);
        let response = await this.FetchAllForTalentPositionRequest.get(requestOptions).catch(e => {
            console.warn('ERROR:getmeetings ', e)
            throw new Error('Something went wrong')
        });

        if (!TB.has(response, 'success.data.meetings')) {
            throw new Error('Something went wrong')
        }

        return TB.orderBy(this.makeMany([...response.success.data.meetings]), 'created_at');
    }

    static async fetchMeetingsForOpportunityCandidate(candidateId, requestOptions = {}) {

        this.FetchAllForOpportunityRequest = TB.request(`/api/meetings/job-candidates/${candidateId}`);
        let response = await this.FetchAllForOpportunityRequest.get(requestOptions).catch(e => {
            console.warn('ERROR:getmeetings ', e)
            throw new Error('Something went wrong')
        });

        if (!TB.has(response, 'success.data.meetings')) {
            throw new Error('Something went wrong')
        }

        return this.makeMany([...response.success.data.meetings]);
    }

    // static async archiveMeetingForTalentPosition(positionId, meetingId) {
    //     this.ArchiveMeetingForTalentPositionRequest = TB.request(`/api/meetings/${meetingId}/positions/${positionId}/archive`);

    //     let response = await this.ArchiveMeetingForTalentPositionRequest.post().catch(console.warn)

    //     if (!TB.has(response, 'success.data')) {
    //         throw new Error('Something went wrong')
    //     }

    //     return true;
    // }

    // static async archiveMeetingForTalentOpp(oppId, meetingId) {
    //     this.ArchiveMeetingForTalentOppRequest = TB.request(`/api/meetings/${meetingId}/talent-opps/${oppId}/archive`);

    //     let response = await this.ArchiveMeetingForTalentOppRequest.post().catch(console.warn)

    //     if (!TB.has(response, 'success.data')) {
    //         throw new Error('Something went wrong')
    //     }

    //     return true;
    // }

    static async confirmCompleteMeetingForTalentPosition(positionId, meetingId) {
        this.ConfirmCompleteMeetingForTalentPosition = TB.request(`/api/meetings/${meetingId}/confirm`);

        let response = await this.ConfirmCompleteMeetingForTalentPosition.post().catch(console.warn)

        if (!TB.has(response, 'success.data')) {
            throw new Error('Something went wrong')
        }

        return true;
    }

    static async cancelMeetingForTalentPosition(positionId, meetingId, reasonId) {
        this.CancelMeetingForTalentPositionRequest = TB.request(`/api/meetings/${meetingId}/cancel`, {
            cancel_reason: reasonId,
        });

        let response = await this.CancelMeetingForTalentPositionRequest.post().catch(console.warn)

        if (!TB.has(response, 'success.data')) {
            throw new Error('Something went wrong')
        }

        return true;
    }

    static async cancelMeetingForTalentCandidate(candidateId, meetingId, reasonId) {
        this.CancelMeetingForTalentCandidateRequest = TB.request(`/api/meetings/${meetingId}/job-candidates/${candidateId}/cancel`, {
            cancel_reason: reasonId,
        });

        let response = await this.CancelMeetingForTalentCandidateRequest.post().catch(console.warn)

        if (!TB.has(response, 'success.data')) {
            throw new Error('Something went wrong')
        }

        return true;
    }

    static async requestInterviewForTalent({positionId, projectId, talentId}, meeting) {

        let {
            name,
            available_slots = [],
            created_timezone,
            member_ids = [],
            conference_link,
            save_conference_link
        } = {...meeting};

        if (!name || !available_slots.length || !conference_link) {
            throw new Error("Invalid Input")
        }

        let requestEndpoint = `/api/meetings/positions/${positionId}/candidates/${talentId}/create`
        if (!positionId && projectId) {
            requestEndpoint = `/api/meetings/projects/${projectId}/team-candidates/${talentId}/create`;
        }
        this.RequestInterviewForTalentRequest = TB.request(
            requestEndpoint,
            {
                name,
                available_slots,
                created_timezone,
                member_ids,
                conference_link,
                type: 1,
                save_conference_link,
            }
        )

        let response = await this.RequestInterviewForTalentRequest.post().catch(console.warn)

        if (!TB.has(response, 'success.data.meeting')) {
            throw new Error("Something went wrong")
        }

        if (save_conference_link) {
            await TB.auth().persistConferenceLinkToProfile(conference_link);
        }
        return this.make({...response.success.data.meeting})
    }

    static async updateInterviewForTalent(positionId, userId, meeting) {

        let {
            name,
            member_ids = [],
            conference_link,
            ended_at,
            save_conference_link
        } = {...meeting};

        if (!name || !conference_link || !meeting.id) {
            throw new Error("Invalid Input")
        }


        this.UpdateInterviewForTalentRequest = TB.request(
            `/api/meetings/${meeting.id}/update`,
            {
                name,
                member_ids,
                conference_link,
                ended_at,
                save_conference_link
            }
        )

        let response = await this.UpdateInterviewForTalentRequest.post().catch(console.warn)

        if (!TB.has(response, 'success.data.meeting')) {
            throw new Error("Something went wrong")
        }
        if (save_conference_link) {
            await TB.auth().persistConferenceLinkToProfile(conference_link);
        }
        return this.make({...response.success.data.meeting})
    }

    static async rescheduleInterviewForTalent(positionId, userId, meeting) {

        let {
            name,
            available_slots = [],
            created_timezone,
            member_ids = [],
            conference_link,
            rescheduled_at,
            save_conference_link,
        } = {...meeting};

        if (!name || !conference_link || !created_timezone || !available_slots.length || !meeting.id) {
            throw new Error("Invalid Input")
        }


        this.RescheduleInterviewForTalentRequest = TB.request(
            `/api/meetings/${meeting.id}/reschedule`,
            {
                name,
                available_slots,
                created_timezone,
                member_ids,
                conference_link,
                rescheduled_at,
                save_conference_link
            }
        )

        let response = await this.RescheduleInterviewForTalentRequest.post().catch(console.warn)

        if (!TB.has(response, 'success.data.meeting')) {
            throw new Error("Something went wrong")
        }
        if (save_conference_link) {
            await TB.auth().persistConferenceLinkToProfile(conference_link);
        }
        return this.make({...response.success.data.meeting})
    }

    static async confirmInterviewForTalent(meetingId, candidateId, params) {

        this.ConfirmInterviewForTalentRequest = TB.request(`/api/meetings/${meetingId}/job-candidates/${candidateId}/schedule`, params)

        let response = await this.ConfirmInterviewForTalentRequest.post().catch(console.warn)

        if (!TB.has(response, 'success.data.meeting')) {
            throw new Error("Something went wrong")
        }

        return this.make({...response.success.data.meeting})
    }

    static async addNoteForMeeting(positionId, meetingId, note) {

        this.AddNoteForMeetingRequest = TB.request(`/api/meetings/${meetingId}/notes/edit`,
            {...note}
        )

        let response = await this.AddNoteForMeetingRequest.post().catch(console.warn)

        if (!TB.has(response, 'success.data.note')) {
            throw new Error("Something went wrong")
        }

        return response.success.data.note
    }

    createFromExisting() {
        let clientMembers = this.clientMembers() || [];
        // let available_slots = this.slotsAvailableToSelect();
        return Meeting.make({
            ...this,
            duration: undefined,
            declined_slots: this.available_slots,
            available_slots: [],
            members: clientMembers,
            member_ids: TB.map(clientMembers || [], 'id')
        });
    }
    talent() {
        return TB.find(this.members, member => member.isTalent())
    }

    confirmedCompletion() {
        return this.confirmed_at;
    }

    statusName()
    {
        if(this.requestedRescheduleByTalent()) {
            return "Talent Requests New Times"
        }
        if (this.wasRejectedByTalent()) {
            if (this.started_at) {
                return "Canceled by Talent"
            }
            return "Rejected by Talent"
        }
        if (this.wasCancelledByClient()) {
            return "Canceled by Organizer"
        }

        switch (this.status)
        {
            case 'Proposed':
                if (this.rescheduled_at) {
                    return 'Updated, Proposed New Times'
                }
                return this.status;
            case 'Upcoming':
            case 'Rejected':
            case 'Expired':
                return this.status;
            case 'Completed':
            case 'Past':
                return 'Completed'
        }
    }

    statusClass() {
        if (this.requestedRescheduleByTalent()) {
            return "warning"
        }
        if (this.rejected_at) {
            return 'danger'
        }
        if (this.hasExpired()) {
            return 'expired'
        }
        if (!this.started_at) {
            return "info"
        }
        if (TB.moment().isBefore(this.started_at)) {
            return "secondary"
        }
        return "dark"
    }

    groupedAvailableSlots() {
        if (!this.available_slots?.length) return [];

        let slots = TB.map(this.available_slots, slot => {
            return {
                ...slot,
                has_passed: TB.moment().isSameOrAfter(slot.started_at),
                selected: TB.moment(this.started_at).isSame(slot.started_at),
                duration: TB.moment(slot.ended_at).diff(slot.started_at, 'minutes') + " min."
            }
        })

        return TB.groupBy(slots, slot =>
            TB.applyTimezoneToDateTime(slot.started_at, this.created_timezone).startOf('day').toISOString()
        );
    }

    slotsAvailableToSelect() {
        if (!this.available_slots?.length) return [];

        return TB.filter(this.available_slots, slot => TB.moment().isBefore(slot.started_at));
    }


    groupedSlotsAvailableToSelect() {
        if (!this.available_slots?.length) return [];

        let slots = TB.map(this.available_slots, slot => {
            return {
                ...slot,
                has_passed: TB.moment.utc(slot.started_at).isSameOrBefore(TB.moment.utc()),
                selected: TB.moment(this.started_at).isSame(slot.started_at),
                duration: TB.moment(slot.ended_at).diff(slot.started_at, 'minutes') + " min."
            }
        })

        return TB.groupBy(slots, slot =>
            TB.applyTimezoneToDateTime(slot.started_at, this.created_timezone).startOf('day').toISOString()
        );
    }

    hasExpired() {
        return !this.started_at && !TB.filter(this.available_slots, slot => TB.moment.utc().isBefore(TB.moment.utc(slot.started_at))).length
    }

    awaitingConfirmationByTalent() {
        return !this.rejected_at && !this.hasExpired() && !this.started_at
    }

    talentMembers() {
        return TB.filter(this.members, member => member.isTalent())
    }

    clientMembers(includeCreator = false) {
        let members = TB.filter(this.members, member => member.isClient())

        if(!includeCreator) {
            members = TB.filter(members, member => member.id !== this.creator.id)
        }

        return members;
    }

    isUserAttendee(user_id) {
        return TB.find(this.attendees(), {id: user_id})
    }

    attendees(includeCreator = false) {
        let attendees = this.clientMembers(includeCreator);
        if (this.started_at) {
            attendees = [...this.talentMembers(), ...attendees]
        }
        return attendees;
    }

    wasRejectedByTalent() {
        return this?.rejection?.activity === 'Talent Rejected Meeting'
    }

    requestedRescheduleByTalent() {
        return this?.rejection?.activity === 'Talent Request Reschedule'
    }

    wasCancelledByClient() {
        return this?.rejection?.activity === 'Client Cancelled Meeting'
    }

    requestedRescheduleByClient() {
        // return !this.started_at && this?.rejection?.activity === 'Client Request Reschedule'
        return this?.rejection?.activity === 'Client Request Reschedule'
    }

    hasPassed() {
        return this.status === 'Completed' || this.status === 'Past'
    }

    canRequestNewInterview() {
        // check that there are no pending requests already
        return true
    }

    canEdit() {
        return this.status === 'Upcoming'
    }

    canReschedule() {
        return !this.hasPassed()
            && !this.wasCancelledByClient()
            && !this.wasRejectedByTalent()
    }

    canCancel() {
        return !this.hasExpired() && !this.rejected_at && !this.hasPassed()
    }

    acceptedTime() {
        if(this.started_at){
            let timezone = TB.getTimezoneAbbrFromOption(this.started_at,this.created_timezone)
            let startingTime = TB.moment.utc(this.started_at);
            let endingTime = TB.moment.utc(this.ended_at);

            return `${TB.applyTimezoneToDateTime(startingTime, this.created_timezone).format("ddd M/D/YY h:mm")} - ${TB.applyTimezoneToDateTime(endingTime, this.created_timezone).format('h:mm a')} ${timezone}`
        }
        if (this.wasCancelledByClient() || this.wasRejectedByTalent()) {
            return ''
        }

        if (this.hasExpired()) {
            return 'Expired: No response'
        }
        return 'Pending'
    }

    timeZone() {

        return this.created_timezone || 'N/A';
        // TODO Get actual timezone
        let date = this.started_at || TB.first(this.available_slots);

        if (!date) return 'N/A';

        let zone = TB.moment(date).toDate();
        const dtf = Intl.DateTimeFormat(undefined, {timeZoneName: 'long'});
        const result = dtf.formatToParts(zone).find((part) => part.type == 'timeZoneName').value;

        // zone = TB.first(TB.values(laravel.talent_questions.time_zones), ['utc_offset', -zone]);
        if (!result) return 'N/A';

        return result + " ("+ zone.toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2] + ")"
    }

    differentTimezoneThanAuth() {
        return Meeting.timezoneAbbreviations[this.created_timezone] !== TB.currentTimezone();
    }

    timeZoneFormat() {
        return Meeting.timezoneAbbreviations[this.created_timezone]
    }

    ratings() {
        return TB.filter(this.notes || [], note => TB.has(note, 'additional_data.rating'));
    }
    averageRating() {
        let ratings = this.ratings();

        if (!ratings?.length) return false;

        return TB.meanBy(ratings, 'additional_data.rating')
    }
    ratingForMember(creator_id) {
        let rating = TB.find(this.notes || [], ['creator.id', creator_id || TB.auth().user()?.id]);
        if (!rating) return false;

        return TB.get(rating, 'additional_data.rating')
    }
}

// const archiveMeetingForTalentPosition = async(positionId, meetingId) => {
//     return Meeting.archiveMeetingForTalentPosition(positionId, meetingId);
// }
// const archiveMeetingForTalentOpp = async(oppId, meetingId) => {
//     return Meeting.archiveMeetingForTalentOpp(oppId, meetingId);
// }

const confirmCompleteMeetingForTalentPosition = async(positionId, meetingId) => {
    return Meeting.confirmCompleteMeetingForTalentPosition(positionId, meetingId);
}

const cancelMeetingForTalentPosition = async(positionId, meetingId, reasonId) => {
    return Meeting.cancelMeetingForTalentPosition(positionId, meetingId, reasonId);
}
const cancelMeetingForTalentOpp = async(candidateId, meetingId, reasonId) => {
    return Meeting.cancelMeetingForTalentCandidate(candidateId, meetingId, reasonId);
}

const requestRescheduleMeetingForTalentOpp = async(candidateId, meetingId) => {
    return Meeting.cancelMeetingForTalentCandidate(candidateId, meetingId, Meeting.talent_reschedule_reason().value);
}

const addNoteForMeeting = async(positionId, meetingId, props) => {
    return Meeting.addNoteForMeeting(positionId, meetingId, props)
}

const requestOrUpdateInterviewForTalent = async({positionId, talentId, projectId}, props, forReschedule = false) => {

    if (forReschedule) {
        return Meeting.rescheduleInterviewForTalent(positionId, talentId, props)
    }else if (props.id) {
        return Meeting.updateInterviewForTalent(positionId, talentId, props)
    }

    return Meeting.requestInterviewForTalent({positionId, talentId, projectId}, props)
}

const confirmInterviewForTalent = async(meetingId, candidateId, props) => {
    return Meeting.confirmInterviewForTalent(meetingId, candidateId, props)
}

export {
    // archiveMeetingForTalentPosition,
    // archiveMeetingForTalentOpp,
    cancelMeetingForTalentPosition,
    confirmCompleteMeetingForTalentPosition,
    cancelMeetingForTalentOpp,
    requestOrUpdateInterviewForTalent,
    confirmInterviewForTalent,
    addNoteForMeeting,
    requestRescheduleMeetingForTalentOpp
}